function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33.818,
    viewBox: "0 0 48 33.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M47 80.917a6.031 6.031 0 0 0-4.244-4.271C39.01 75.636 24 75.636 24 75.636s-15.01 0-18.753 1.01A6.031 6.031 0 0 0 1 80.917c-1 3.767-1 11.628-1 11.628s0 7.861 1 11.628a6.031 6.031 0 0 0 4.244 4.271c3.746 1.01 18.756 1.01 18.756 1.01s15.01 0 18.753-1.009A6.031 6.031 0 0 0 47 104.174c1-3.768 1-11.628 1-11.628s0-7.862-1-11.629z",
    style: {
      fill: "red"
    },
    transform: "translate(0 -75.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.636 194.146 12.545-7.137-12.545-7.137z",
    transform: "translate(-184.545 -170.1)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeplay);
export default __webpack_public_path__ + "static/media/youtubeplay.c586159896dd31ebc45176b1d725e281.svg";
export { ForwardRef as ReactComponent };